import getLocal from '@/app/utils/getLocal';
import classNames from 'classnames';
import React from 'react';
import './index.scss';
import EFPicture from 'elem/ui/ef-picture';

export interface EfCompareSpecTHeadProps {
    /**
     * 产品图片：png格式
     */
    img: string;
    /**
     * 产品标题名称
     */
    title: string;
    /**
     * 产品tag， 如 NEW
     */
    tag?: string;
}

export interface EfCompareSpecGridProps {
    /**
     * Grid格子中的title
     */
    title: string;
    /**
     * Grid格子中的desc
     */
    desc?: string;
}

export interface EfCompareSpecDataProps {
    /**
     * 表头内容
     */
    thead: EfCompareSpecTHeadProps[];
    /**
     * 表中内容
     */
    tbody: EfCompareSpecGridProps[][];
}

export interface EfCompareSpecProps {
    /**
     * table表单
     */
    data: EfCompareSpecDataProps;
    /**
     * 样式名
     */
    className?: string;
}

/**
 * 维护: kalkin
 *
 * 产品对比
 */
const EfCompareSpec: React.FC<EfCompareSpecProps> = ({ data, className }) => {
    const { locale = 'us' } = getLocal();
    const [isClient, setIsClient] = React.useState(false);
    const prefixCls = `ef-compare-spec`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });

    const { thead, tbody } = data;

    React.useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <>
            <div className={`${classes}`}>
                {isClient && (
                    <div className={`${prefixCls}-table-wrapper`}>
                        <table className={`${prefixCls}-table`}>
                            <thead className={`${prefixCls}-thead`}>
                                <tr className={`${prefixCls}-tr ${prefixCls}-thead-tr`}>
                                    {thead?.map((head: EfCompareSpecTHeadProps, k: number) => (
                                        <th className={`${prefixCls}-th ${prefixCls}-td`} key={k}>
                                            {head?.img && (
                                                <div className={`${prefixCls}-img`}>
                                                    <EFPicture src={head?.img} alt={head?.title} />
                                                </div>
                                            )}
                                            <div className={`${prefixCls}-info${head?.tag ? ' has-tag' : ''}`}>
                                                {head?.tag && <p className={`${prefixCls}-tag`}>{head?.tag}</p>}
                                                <p className={`${prefixCls}-bold ${prefixCls}-text ${prefixCls}-title`}>{head?.title}</p>
                                            </div>
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody className={`${prefixCls}-tbody`}>
                                {tbody?.map((row: EfCompareSpecGridProps[], m: number) => (
                                    <tr className={`${prefixCls}-tr`} key={`${m}`}>
                                        {row?.map((col: EfCompareSpecGridProps, n: number) => (
                                            <td className={`${prefixCls}-td`} key={`${m}_${n}td`}>
                                                <p className={`${prefixCls}-td-title`}>{col?.title}</p>
                                                {col?.desc && <p className={`${prefixCls}-td-desc`}>{col?.desc}</p>}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </>
    );
};

export default EfCompareSpec;
